import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { DvsCheckResponse } from '#api/tmsApiService'
import { type ResultUpdater, runCheck } from '#app/store/middlewares/configurationRequests/checks/runCheck'
import type { TruckConfiguration } from '#store/slices/configurationSlice'
import type { CheckResult, CheckTaskId } from '#types/ConfigurationCheck'
import type { AppListenerApi } from '../../configurationRequestMiddleware'

export const dvsCheckId = 'checkDvs' as CheckTaskId

export function isDvsResult(result: CheckResult): result is CheckResult<DvsCheckResponse> {
  return result.id === dvsCheckId
}

export function runDvsCheck(api: AppListenerApi, configuration: TruckConfiguration, updater: ResultUpdater) {
  if (!configuration.uuid) {
    return
  }
  const promise = api.dispatch(
    enhancedTmsApiService.endpoints.getConfigurationByUuidCheckDvs.initiate(
      { uuid: configuration.uuid },
      {
        forceRefetch: true,
      },
    ),
  )

  return runCheck(
    promise,
    {
      id: dvsCheckId,
    },
    updater,
  )
}
